import { isMain } from '@/utils/tools'
// -------------------------------------------------------------
// 高校公益
let publicWelfare = () => import( /* webpackChunkName: "group-public_welfare" */ '@/views/other/public_welfare/index');
// 线上--基础班查询
let onlineBaseClass = () => import( /* webpackChunkName: "group-online_base_class" */ '@/views/other/online_base_class/index');
// 线上--基础班查询--个人信息
let onlineBaseUserinfo = () => import( /* webpackChunkName: "group-online_base_userinfo" */ '@/views/other/online_base_userinfo/index');
// 支付抢购
let rushPurchase = () => import( /* webpackChunkName: "group-rush_purchase" */ '@/views/other/rush_purchase/index');
// 支付抢购成功
let rushPurchaseSuccess = () => import( /* webpackChunkName: "group-rush_purchase" */ '@/views/other/rush_purchase/success');
// 测试支付
let testPay = () => import( /* webpackChunkName: "group-testpay" */ '@/views/other/testpay/index');
// 新媒体落地页
let mediaLandingPage = () => import( /* webpackChunkName: "group-media_landing_page" */ '@/views/other/media_landing_page/index');
// 新媒体落地页(KOL)
let mediaLandingKol = () => import( /* webpackChunkName: "group-media_landing_kol" */ '@/views/other/media_landing_kol/index');
// 9.9抢购页面
let mediaLandingRush = () => import( /* webpackChunkName: "group-media_landing_rush" */ '@/views/other/media_landing_rush/index');
let mediaLandingRush2 = () => import( /* webpackChunkName: "group-media_landing_rush" */ '@/views/other/media_landing_rush/index2');
let mediaLandingRush3 = () => import( /* webpackChunkName: "group-media_landing_rush" */ '@/views/other/media_landing_rush/index3');
let mediaLandingRush4 = () => import( /* webpackChunkName: "group-media_landing_rush" */ '@/views/other/media_landing_rush/index4');
let mediaLandingRush5 = () => import( /* webpackChunkName: "group-media_landing_rush" */ '@/views/other/media_landing_rush/index5');
// 老学员成绩单
let reportCardIndex = () => import( /* webpackChunkName: "group-media_landing_rush" */ '@/views/other/report_card_poster/index');
// 老学员成绩单-填写信息
let reportCardForm = () => import( /* webpackChunkName: "group-media_landing_rush" */ '@/views/other/report_card_poster/form');
// 校友会-开始
let posterCardIndex = () => import( /* webpackChunkName: "group-media_landing_rush" */ '@/views/other/poster_card_poster/index');
// 校友会-生成海报
let posterCardForm = () => import( /* webpackChunkName: "group-media_landing_rush" */ '@/views/other/poster_card_poster/form');
// 梦想闹钟
let alarmClock = () => import( /* webpackChunkName: "group-alarm_clock" */ '@/views/other/alarm_clock/index');
// 520活动
let shengyaActivity520 = () => import( /* webpackChunkName: "shengya_activity_520" */ '@/views/other/shengya/activity520');
// 8月活动
let shengyaActivity816 = () => import( /* webpackChunkName: "shengya_activity_816" */ '@/views/other/shengya/activity816');
// 知识星球退款
let zsxq = () => import( /* webpackChunkName: "zsxq" */ '@/views/other/zsxq/index');

export default [
    {
        path: '/public_welfare',
        name: '加载中',
        component: publicWelfare
    },
    {
        path: '/online_base_class',
        name: '加载中',
        component: onlineBaseClass
    },
    {
        path: '/online_base_userinfo',
        name: '加载中',
        component: onlineBaseUserinfo
    },
    {
        path: '/rush_purchase',
        name: '加载中',
        component: rushPurchase
    },
    {
        path: '/rush_purchase_success',
        name: '加载中',
        component: rushPurchaseSuccess
    },
    {
        path: '/testpay',
        name: '加载中',
        component: testPay
    },
    {
        path: '/media_landing_page',
        name: '加载中',
        component: mediaLandingPage
    },
    {
        path: '/media_landing_kol',
        name: '加载中',
        component: mediaLandingKol
    },
    {
        path: '/media_landing_rush',
        name: '加载中',
        component: mediaLandingRush
    },
    {
        path: '/media_landing_rush2',
        name: '加载中',
        component: mediaLandingRush2
    },
    {
        path: '/media_landing_rush3',
        name: '加载中',
        component: mediaLandingRush3
    },
    {
        path: '/media_landing_rush4',
        name: '加载中',
        component: mediaLandingRush4
    },
    {
        path: '/media_landing_rush5',
        name: '加载中',
        component: mediaLandingRush5
    },
    {
        path: '/report_card_index',
        name: '加载中',
        component: reportCardIndex
    },
    {
        path: '/report_card_form',
        name: '加载中',
        component: reportCardForm
    },
    {
        path: '/poster_card_index',
        name: '加载中',
        component: posterCardIndex
    },
    {
        path: '/poster_card_form',
        name: '加载中',
        component: posterCardForm
    },
    {
        path: '/alarm_clock',
        name: '加载中',
        component: alarmClock
    },
    {
        path: '/shengya_activity_520',
        name: '加载中',
        component: shengyaActivity520
    },
    {
        path: '/shengya_activity_816',
        name: '加载中',
        component: shengyaActivity816
    },
    {
        path: '/zsxq',
        name: '加载中',
        component: zsxq
    },
]